import axios from 'axios';
import { API_BASE_URL } from '../api/config';

export interface MaintenanceStatus {
  is_active: boolean;
  title: string;
  message: string;
  expected_back_at: string | null;
}

// Use a bare axios instance so the maintenance check never triggers the
// JWT-refresh interceptor or fails when the user is unauthenticated.
const publicClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 8000,
});

const maintenanceService = {
  getStatus: async (): Promise<MaintenanceStatus> => {
    const res = await publicClient.get('/api/management/maintenance/status/');
    return res.data;
  },
};

export default maintenanceService;
